export const str = {
  leftPad(str, max, padStr = "0") {
    const paddingValue = new Array(max).fill(padStr).join("");
    return String(paddingValue + str).slice(-paddingValue.length);
  }
};
